var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardLayout',[_c('v-sheet',{staticClass:"mx-12 my-6",attrs:{"slot":"main","rounded":""},slot:"main"},[_c('h1',{staticClass:"outfit-regular mb-3"},[_vm._v("Realm Account")]),_c('v-divider'),_c('v-card',[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.profile)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }